import {
  Box,
  Button,
  Card,
  Container,
  Divider,
  Grid,
  Stack,
  Typography,
} from "@mui/material";
import MailOutlineIcon from "@mui/icons-material/MailOutline";
import CallIcon from "@mui/icons-material/Call";
import LocationOnIcon from "@mui/icons-material/LocationOn";
import FacebookIcon from "@mui/icons-material/Facebook";
import PageLayout from "../../shared/components/PageLayout";
import ContactForm from "../../shared/components/ContactForm";
import { CONTACT_INFO } from "../../shared/utils/constants";
import { customStyles } from "./index.styles";

const ContactUsPage = () => {
  return (
    <PageLayout>
      {/* Hero Section */}
      <Box sx={customStyles.heroSection}>
        <Container>
          <Typography variant="h2" sx={customStyles.heroTitle}>
            Get In Touch
          </Typography>
          <Typography variant="h6" sx={customStyles.heroSubtitle}>
            We'd love to hear from you. Send us a message and we'll respond as
            soon as possible.
          </Typography>
        </Container>
      </Box>

      {/* Main Content */}
      <Container sx={customStyles.contentContainer}>
        <Grid container spacing={4}>
          {/* Contact Form Section */}
          <Grid item xs={12} md={7}>
            <Card sx={customStyles.formCard}>
              <Typography variant="h4" sx={customStyles.sectionTitle}>
                Send Us a Message
              </Typography>

              <Box mt={3}>
                <ContactForm variant="full" />
              </Box>
            </Card>
          </Grid>

          {/* Contact Info Section */}
          <Grid item xs={12} md={5}>
            <Stack spacing={3}>
              {/* Contact Details Card */}
              <Card sx={customStyles.infoCard}>
                <Typography variant="h5" sx={customStyles.infoCardTitle}>
                  Contact Information
                </Typography>

                <Stack spacing={3} mt={3}>
                  {/* Address */}
                  <Box sx={customStyles.contactItem}>
                    <Box sx={customStyles.iconWrapper}>
                      <LocationOnIcon sx={customStyles.contactIcon} />
                    </Box>
                    <Box>
                      <Typography sx={customStyles.contactLabel}>
                        Address
                      </Typography>
                      <Typography sx={customStyles.contactValue}>
                        {CONTACT_INFO.address.line1}
                        <br />
                        {CONTACT_INFO.address.line2}
                        <br />
                        {CONTACT_INFO.address.line3}
                        <br />
                        {CONTACT_INFO.address.line4}
                      </Typography>
                    </Box>
                  </Box>

                  <Divider />

                  {/* Email */}
                  <Box sx={customStyles.contactItem}>
                    <Box sx={customStyles.iconWrapper}>
                      <MailOutlineIcon sx={customStyles.contactIcon} />
                    </Box>
                    <Box>
                      <Typography sx={customStyles.contactLabel}>
                        Email
                      </Typography>
                      <Typography
                        component="a"
                        href={`mailto:${CONTACT_INFO.email}`}
                        sx={customStyles.contactLink}
                      >
                        {CONTACT_INFO.email}
                      </Typography>
                    </Box>
                  </Box>

                  <Divider />

                  {/* Phone */}
                  <Box sx={customStyles.contactItem}>
                    <Box sx={customStyles.iconWrapper}>
                      <CallIcon sx={customStyles.contactIcon} />
                    </Box>
                    <Box>
                      <Typography sx={customStyles.contactLabel}>
                        Phone
                      </Typography>
                      <Typography
                        component="a"
                        href={`tel:${CONTACT_INFO.phone}`}
                        sx={customStyles.contactLink}
                      >
                        {CONTACT_INFO.phoneDisplay}
                      </Typography>
                    </Box>
                  </Box>
                </Stack>
              </Card>

              {/* Social Media Card */}
              <Card sx={customStyles.socialCard}>
                <Typography variant="h5" sx={customStyles.infoCardTitle}>
                  Connect With Us
                </Typography>

                <Stack spacing={2} mt={3}>
                  <Button
                    variant="outlined"
                    startIcon={<FacebookIcon />}
                    sx={customStyles.socialButton}
                    href={CONTACT_INFO.facebook}
                    target="_blank"
                    rel="noopener noreferrer"
                    fullWidth
                  >
                    Follow us on Facebook
                  </Button>

                  <Typography
                    variant="body2"
                    color="text.secondary"
                    sx={{ textAlign: "center", mt: 2 }}
                  >
                    Stay updated with our latest services and offers
                  </Typography>
                </Stack>
              </Card>
            </Stack>
          </Grid>
        </Grid>
      </Container>
    </PageLayout>
  );
};

export default ContactUsPage;
